import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-page03',
  templateUrl: './blog-page03.component.html',
  styleUrls: ['./blog-page03.component.css']
})
export class BlogPage03Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
